export const isPositiveIntStr = (data: string): boolean => {
  if (data.includes(' ')) {
    return false;
  }
  const number = Number(data);
  return (
    Number.isInteger(number) && number >= 0 && data.trim() === number.toString()
  );
};
